import styled from "@emotion/styled";

export const NotFoundPageWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.primaryColors.main,
	width: "100%",
	height: "100vh",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	flexDirection: "column",
	padding: "16px",
	boxSizing: "border-box",
	"> div:first-of-type": {
		maxWidth: "474px",
		width: "100%",
		"> div:first-of-type": {
			boxSizing: "border-box",
			padding: "16px",
			backgroundColor: theme.project.colors.backgroundColors.main,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			width: "100%",
			img: {
				width: "216px",
				height: "53px"
			}
		}
	}
}));
